<template>
  <v-dialog
    ref="dialog"
    v-model="dialogOpened"
    max-width="400"
    scrollable
    persistent
    no-click-animation
    :retain-focus="false"
  >
    <v-card>
      <v-btn class="v-dialog--close" icon @click="reject">
        <v-icon>fal fa-times</v-icon>
      </v-btn>

      <v-card-title class="headline pr-10">
        Raum wirklich wechseln?
      </v-card-title>

      <v-card-text v-if="type">
        <template v-if="type === 'peersBusy'">
          <v-alert type="warning" dense text>
            Du hast noch offene Dateianfragen oder nicht abgeschlossene Dateiübertragungen.
          </v-alert>
          Wenn du den aktuellen Raum verlässt werden alle
          offenen Dateianfragen und
          nicht abgeschlossene Dateiübertragungen
          abgebrochen.
        </template>
        <template v-else-if="type === 'tour'">
          Wenn du den Raum wechselst wird die Hilfe geschlossen.
        </template>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="reject">
          Abbrechen
        </v-btn>

        <v-btn color="red" text @click="resolve">
          Raum wechseln
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Dialog from './Dialog';
  import eventBus from '../../assets/js/event-bus';


  export default {
    name: 'RoomChangeConfirmDialog',

    extends: Dialog,

    data() {
      return {
        type: '',
        resolve: () => {},
        reject: () => {}
      };
    },

    mounted() {
      eventBus.$on('confirmRoomChange', this._onConfirmRoomChange);
    },

    destroyed() {
      eventBus.$off('confirmRoomChange', this._onConfirmRoomChange);
    },

    methods: {
      _onConfirmRoomChange({type, resolve, reject}) {
        this.type = type;

        this.resolve = () => {
          this.hide();
          resolve();
        };
        this.reject = () => {
          this.hide();
          reject();
        };

        this.show();
      }
    }
  };
</script>
